import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type AdminPanelHeaderProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  inset?: boolean;
  className?: string;
};

export function AdminPanelHeader({
  title,
  description,
  action,
  inset = false,
  className,
}: AdminPanelHeaderProps) {
  return (
    <div className={cn("flex flex-wrap items-start justify-between gap-4", inset && "px-5", className)}>
      <div className="min-w-0">
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        {description ? <p className="mt-1 max-w-3xl text-sm text-gray-500">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
